import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { postAPI } from "../../Base/API";
import NotificationManager from '../../Base/NotificationCenter/NotificationStore';
import { authContext } from '../../../Utils/AdalConfig';

// Arranca pre-preenchido com o email do utilizador autenticado (task pede claims),
// por isso o parent so o monta quando abre.
class ConnectivityTestEmailModal extends Component {

    state = {
        email: authContext.getCachedUser()?.profile?.email || '',
        busy: false
    }

    onChangeEmail = (e) => this.setState({ email: e.target.value });

    // Envia teste para o endpoint da task #22887. HTML5 valida o formato (type=email required)
    // antes do submit. Backend recebe [FromBody] string, por isso axios envia a string como JSON string.
    sendTestEmail = (e) => {
        e.preventDefault();
        const { email, busy } = this.state;
        if (busy) return;

        this.setState({ busy: true });
        postAPI(result => {
            const { data, error } = result;
            if (error) {
                NotificationManager.error(this.props.intl.formatMessage({ id: "connectivity.test.errorToast" }), '', 3000);
                this.setState({ busy: false });
                return;
            }
            if (data && data.errors && data.errors.length > 0) {
                NotificationManager.error(data.errors[0].message, '', 3000);
                this.setState({ busy: false });
                return;
            }
            NotificationManager.success(this.props.intl.formatMessage({ id: "connectivity.test.successToast" }), '', 3000);
            this.props.toggle();
        }, '/api/Rate/ConnectivityIncident/v1/config/test', email);
    }

    render() {
        const { email, busy } = this.state;

        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggle}>
                <Form onSubmit={this.sendTestEmail}>
                    <ModalHeader toggle={this.props.toggle}>
                        <FormattedMessage id="connectivity.test.modalTitle" />
                    </ModalHeader>
                    <ModalBody>
                        <div className="text-muted small mb-3">
                            <FormattedMessage id="connectivity.test.modalDescription" />
                        </div>
                        <FormGroup>
                            <Label for="test-email-input">
                                <FormattedMessage id="connectivity.test.emailLabel" />
                            </Label>
                            <Input
                                id="test-email-input"
                                type="email"
                                required
                                maxLength={200}
                                value={email}
                                onChange={this.onChangeEmail}
                                disabled={busy}
                                placeholder={this.props.intl.formatMessage({ id: "connectivity.test.emailLabel" })}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="link" onClick={this.props.toggle} disabled={busy}>
                            <FormattedMessage id="connectivity.test.cancel" />
                        </Button>
                        <Button type="submit" className="btn btn-host" disabled={busy}>
                            <FormattedMessage id="connectivity.test.send" />
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal>
        );
    }
}

export default injectIntl(ConnectivityTestEmailModal);
